import { useStore } from "hooks/use-store";
import { TextStat } from "./text-stat";
import { useTranslation } from "react-i18next";
import { formatImpact } from "utils/formatters";

interface PeakImpactStatProps {
  labelOnTop?: boolean;
}

export const PeakImpactStat = ({ labelOnTop }: PeakImpactStatProps) => {
  const { t } = useTranslation();

  const peakImpact = useStore((state) => state.peakImpact);
  const label = t("dashboard.peak_impact");

  return (
    <TextStat
      label={label}
      value={formatImpact(peakImpact)}
      labelOnTop={labelOnTop}
      labelClassName="fill-primary-400"
      valueClassName="fill-white"
    />
  );
};
